// smooth jump mark scroll

class SmoothJumpMark {
    static smoothAnchorScroll() {
        const anchors = document.querySelectorAll( 'a[href^="#"]' );
        for ( let i = 0; i < anchors.length; i += 1 ) {
            const anchor = anchors[ i ];
            anchor.addEventListener( 'click', function processEveryHref( clickedElement ) {
                clickedElement.preventDefault();
                const jumpToElement = document.querySelector( this.getAttribute( 'href' ) );
                if ( jumpToElement ) {
                    document.querySelector( this.getAttribute( 'href' ) ).scrollIntoView( {
                        behavior: 'smooth',
                    } );
                }
            } );
        }
    }
}

export default SmoothJumpMark;
